module.exports = __webpack_public_path__ + "static/media/server.5f049c4e.svg";